export enum ContentType {
  Arabic = 'Arabic',
  Pinoy = 'Pinoy',
  Other = 'Other',
  NotSpecified = 'Not specified',
}
